import * as i0 from '@angular/core';
import { Injectable, Component, ChangeDetectionStrategy, Input, NgModule } from '@angular/core';
import * as i1 from '@angular/forms';
import { FormGroup, Validators, FormControl, ReactiveFormsModule } from '@angular/forms';
import { Subject } from 'rxjs';
import * as errorUtils from 'error-message-utility';
import * as i2 from 'cache-country-list';
import * as i3 from 'app-services-library';
import * as i4 from 'reference-library';
import * as i5 from '@angular/common';
import { CommonModule } from '@angular/common';

class VdPhoneService {
    constructor() { }
}
VdPhoneService.ɵfac = function VdPhoneService_Factory(t) { return new (t || VdPhoneService)(); };
VdPhoneService.ɵprov = i0.ɵɵdefineInjectable({ token: VdPhoneService, factory: VdPhoneService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(VdPhoneService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return []; }, null); })();

function VdPhoneComponent_em_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "em", 7);
    i0.ɵɵtext(1, "*");
    i0.ɵɵelementEnd();
} }
function VdPhoneComponent_option_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "option", 8);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const data_r4 = ctx.$implicit;
    i0.ɵɵproperty("value", data_r4.phoneCode);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1("", data_r4.countyWithCode, " ");
} }
function VdPhoneComponent_span_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 9);
    i0.ɵɵtext(1, " Required ");
    i0.ɵɵelementEnd();
} }
function VdPhoneComponent_span_9_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 9);
    i0.ɵɵtext(1, " Required ");
    i0.ɵɵelementEnd();
} }
class VdPhoneComponent {
    // @Input() DataArr: any = []
    constructor(fb, cc, ch, appServicesLibraryService, referenceLibraryService) {
        this.fb = fb;
        this.cc = cc;
        this.ch = ch;
        this.appServicesLibraryService = appServicesLibraryService;
        this.referenceLibraryService = referenceLibraryService;
        this.group = new FormGroup({});
        // @Input() vdphone: FormGroup;
        this.observableSubscription$ = new Subject();
        this.Arr = [];
    }
    ngOnInit() {
        // console.log("phone contact this.group", this.group);
        this.initform();
    }
    ngAfterViewInit() {
        this.appServicesLibraryService.reportLoaded();
    }
    // ngAfterViewInit() {
    //   this.initform();
    // }
    initform() {
        // var destinationObj = {};
        try {
            let fmg = Object.assign(this.groupName);
            this.cc.getCountry().subscribe((data) => {
                data.map(x => x.countyWithCode = x.countryName + "-" + x.phoneCode);
                this.referenceLibraryService.translateArray(data, 'countyWithCode')
                    .then(translated => {
                    this.DataArr = translated;
                    this.ch.detectChanges();
                })
                    .catch(error => console.error("Translation error:", error));
                // this.DataArr.forEach((data: any) => {
                //   console.log(data.countryName);
                //   this.Arr = data.counrtyName
                // })
            });
            // this.group.addControl(fmg, new FormGroup({
            //   dropdown: new FormControl(this.dropdown),
            //   tel: new FormControl(this.tel)
            // })
            // );
            let dropdown = this.inputParams.value && this.inputParams.value.dropdown ? this.inputParams.value.dropdown : '';
            let tel = this.inputParams.value && this.inputParams.value.tel ? this.inputParams.value.tel : '';
            const phoneNoValidators = this.inputParams.mandatory ? [Validators.required] : [];
            try {
                this.group.addControl(fmg, new FormGroup({
                    dropdown: new FormControl(dropdown, phoneNoValidators),
                    tel: new FormControl(tel, phoneNoValidators)
                }));
            }
            catch (error) {
                console.log("Vd Phone", error);
            }
        }
        catch (error) {
            console.log(error);
        }
    }
    valueChange(e) {
        // console.log(e)
        this.selected = e.target.value;
        // console.log(this.selected)
    }
    validate(event) {
        var charCode = (event.which) ? event.which : event.keyCode;
        if ((charCode < 48 || charCode > 57)) {
            event.preventDefault();
            return false;
        }
        else {
            return true;
        }
    }
    getGlobalErrorMessages(error) {
        return errorUtils.errorMessages.get(error);
    }
}
VdPhoneComponent.ɵfac = function VdPhoneComponent_Factory(t) { return new (t || VdPhoneComponent)(i0.ɵɵdirectiveInject(i1.FormBuilder), i0.ɵɵdirectiveInject(i2.CacheCountryListService), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i3.AppServicesLibraryService), i0.ɵɵdirectiveInject(i4.ReferenceLibraryService)); };
VdPhoneComponent.ɵcmp = i0.ɵɵdefineComponent({ type: VdPhoneComponent, selectors: [["lib-vd-phone"]], inputs: { groupName: "groupName", value: "value", inputParams: "inputParams", group: "group" }, decls: 10, vars: 7, consts: [[3, "formGroup"], [1, "inline", 3, "formGroupName"], ["class", "error-indicator", 4, "ngIf"], ["formControlName", "dropdown", 1, "form-control", 3, "change"], [3, "value", 4, "ngFor", "ngForOf"], ["class", "error", 4, "ngIf"], ["type", "text", "formControlName", "tel", 1, "form-control", 3, "maxlength", "keypress"], [1, "error-indicator"], [3, "value"], [1, "error"]], template: function VdPhoneComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵelementStart(1, "div", 1);
        i0.ɵɵtemplate(2, VdPhoneComponent_em_2_Template, 2, 0, "em", 2);
        i0.ɵɵelementStart(3, "select", 3);
        i0.ɵɵlistener("change", function VdPhoneComponent_Template_select_change_3_listener($event) { return ctx.valueChange($event); });
        i0.ɵɵtemplate(4, VdPhoneComponent_option_4_Template, 2, 2, "option", 4);
        i0.ɵɵelementEnd();
        i0.ɵɵelement(5, "br");
        i0.ɵɵtemplate(6, VdPhoneComponent_span_6_Template, 2, 0, "span", 5);
        i0.ɵɵelementStart(7, "input", 6);
        i0.ɵɵlistener("keypress", function VdPhoneComponent_Template_input_keypress_7_listener($event) { return ctx.validate($event); });
        i0.ɵɵelementEnd();
        i0.ɵɵelement(8, "br");
        i0.ɵɵtemplate(9, VdPhoneComponent_span_9_Template, 2, 0, "span", 5);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵproperty("formGroup", ctx.group);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("formGroupName", ctx.groupName);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.inputParams == null ? null : ctx.inputParams.mandatory);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngForOf", ctx.DataArr);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", (ctx.inputParams == null ? null : ctx.inputParams.mandatory) && ctx.group.get(ctx.inputParams.name).touched && ctx.group.get(ctx.inputParams.name).get("dropdown").value === "");
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("maxlength", ctx.inputParams == null ? null : ctx.inputParams.maxLength);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", (ctx.inputParams == null ? null : ctx.inputParams.mandatory) && ctx.group.get(ctx.inputParams.name).touched && ctx.group.get(ctx.inputParams.name).get("tel").value === "");
    } }, directives: [i1.NgControlStatusGroup, i1.FormGroupDirective, i1.FormGroupName, i5.NgIf, i1.SelectControlValueAccessor, i1.NgControlStatus, i1.FormControlName, i5.NgForOf, i1.DefaultValueAccessor, i1.MaxLengthValidator, i1.NgSelectOption, i1.ɵangular_packages_forms_forms_z], styles: [".inline[_ngcontent-%COMP%]{display:flex}.error[_ngcontent-%COMP%], .error-indicator[_ngcontent-%COMP%]{font-size:12px;color:#e31302;padding-top:3px}.error-indicator[_ngcontent-%COMP%]{position:relative;bottom:22px;left:92px}"], changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(VdPhoneComponent, [{
        type: Component,
        args: [{
                selector: 'lib-vd-phone',
                templateUrl: 'vd-phone.component.html',
                styleUrls: ['vd-phone.component.scss'],
                changeDetection: ChangeDetectionStrategy.OnPush
            }]
    }], function () { return [{ type: i1.FormBuilder }, { type: i2.CacheCountryListService }, { type: i0.ChangeDetectorRef }, { type: i3.AppServicesLibraryService }, { type: i4.ReferenceLibraryService }]; }, { groupName: [{
            type: Input
        }], value: [{
            type: Input
        }], inputParams: [{
            type: Input
        }], group: [{
            type: Input
        }] }); })();

class VdPhoneModule {
}
VdPhoneModule.ɵfac = function VdPhoneModule_Factory(t) { return new (t || VdPhoneModule)(); };
VdPhoneModule.ɵmod = i0.ɵɵdefineNgModule({ type: VdPhoneModule });
VdPhoneModule.ɵinj = i0.ɵɵdefineInjector({ imports: [[
            ReactiveFormsModule,
            CommonModule
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(VdPhoneModule, { declarations: [VdPhoneComponent], imports: [ReactiveFormsModule,
        CommonModule], exports: [VdPhoneComponent] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(VdPhoneModule, [{
        type: NgModule,
        args: [{
                declarations: [VdPhoneComponent],
                imports: [
                    ReactiveFormsModule,
                    CommonModule
                ],
                exports: [VdPhoneComponent]
            }]
    }], null, null); })();

/*
 * Public API Surface of vd-phone
 */

/**
 * Generated bundle index. Do not edit.
 */

export { VdPhoneComponent, VdPhoneModule, VdPhoneService };
//# sourceMappingURL=vd-phone.js.map
